import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { UiPipesModule } from '@netfoundry-ui/ui/pipes';
import { SideNavigatorComponent } from './side-navigator/side-navigator.component';
import { FeatureItemSelectorModule } from "@netfoundry-ui/feature/item-selector";
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
    imports: [CommonModule, RouterModule, ClickOutsideModule, FormsModule, UiPipesModule, FeatureItemSelectorModule, ScrollingModule],
    declarations: [SideNavigatorComponent],
    exports: [SideNavigatorComponent],
})
export class FeatureNavigatorModule {}
